import { useMemo } from 'react';

import { usePlatformUi } from '../../features/platform/platform-api';
import { PLAYER_NAV, type NavItem } from './nav-items';

const RATING_PATH = '/rounds/rating';

/** Player menu with optional «Рейтинг» tab controlled by platform settings. */
export function usePlayerNav(): readonly NavItem[] {
  const ui = usePlatformUi();

  return useMemo(() => {
    const showRating = ui.data?.showRatingInMenu ?? false;
    if (showRating) return PLAYER_NAV;
    return PLAYER_NAV.filter((item) => item.to !== RATING_PATH);
  }, [ui.data?.showRatingInMenu]);
}
